import Button from "@ergeon/core-components/exports/Button.ts";
import { ComponentType } from 'react';
import clsx from 'clsx';

import UiCloseIcon from '@/icons/UiCloseIcon';
import UiOkIcon from '@/icons/UiOkIcon';

import './LobbyPage.css';

interface PermissionRowProps {
  Icon: ComponentType<{ className?: string }>;
  name: string;
  granted: boolean;
  onEnable(): void;
}

/**
 * One line of the lobby checklist. A granted permission is the normal case and
 * states itself quietly; a missing one is the whole reason the checklist is
 * here, so it keeps the card and the button that fixes it.
 */
export default function PermissionRow({ Icon, name, granted, onEnable }: PermissionRowProps) {
  const icon = <Icon className={clsx('size-6', { 'svg-fill-black': granted })} />;

  if (granted) {
    return (
      <div className="flex w-full items-center gap-1.5 px-1">
        <span className="flex w-8 justify-center">{icon}</span>
        <span className="text-gray-500 dark:text-gray-400">{name} is enabled</span>
        <span className="ml-auto"><UiOkIcon /></span>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between gap-5 rounded-xl bg-whitesmoke p-3 dark:bg-gray-800">
      <div className="flex items-center gap-1.5">
        <span className="relative flex w-8 justify-center">
          {icon}
          <span className="absolute -bottom-0.5 right-1 flex size-3 items-center justify-center rounded-icon-circle border border-solid border-white bg-orange-base dark:border-gray-800">
            <UiCloseIcon />
          </span>
        </span>
        <span>{name} is disabled</span>
      </div>
      <Button flavor="primary" onClick={onEnable} size="small">
        Enable
      </Button>
    </div>
  );
}
